import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { LOCK_ICON } from '../../constant/image';

interface ComingSoonProps {
  display: boolean;
  date: string;
}
export function ComingSoon({ display, date }: ComingSoonProps) {
  if (!display) {
    return null;
  }

  return (
    <Wrapper>
      <Inner>
        <Content>
          <Title variant='Body_16_SemiBold'>
            <img src={LOCK_ICON} />
            {date} 오픈 예정
          </Title>
          <SubTitle variant='Body_14_Medium'>이 상품은 오픈 예정 상품이에요</SubTitle>
          <SubTitle variant='Body_14_Medium'>조금만 기다려주세요</SubTitle>
        </Content>
      </Inner>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: 8px 8px 0 0;
  background: rgba(255, 255, 255, 0.7);
`;

const Inner = styled.div`
  position: relative;
  height: 100%;
`;
const Content = styled.div`
  position: absolute;
  width: 293px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px;
  background: ${vars.color.backgroundOnSurface};
  border: 1px solid ${vars.color.borderSecondary};
  border-radius: 8px;
`;

const Title = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  img {
    width: 24px;
  }
`;

const SubTitle = styled(Text)``;
